export default "__VITE_ASSET__Bipt5jO$__"